import { getAlertIdsForUserStaticWorkflow } from '../workflow'

async function findData(context, callback) {
    const alertIds = await getAlertIdsForUserStaticWorkflow(context, { active: true })

    return [
        {
            id: "000000000000000000000002",
            data: alertIds.length
        }
    ]
}

export const entity = {
    name: 'CurrentUserAlerts',
    dashboard: true,
    fields: ["id", "subTitle", "data"],
    find: function(context, callback) {
        this.prepareContext(context, 'L', (error, context) => {
            if (error) callback(error)
            else
                findData(context)
                    .then(objects => callback(null, objects))
                    .catch(error => callback(error))
        })
    }
}
